module.exports = __webpack_public_path__ + "img/OEE@3x.5e9cd547.png";